import React, { useState, useContext, forwardRef } from 'react'
// import { translate } from 'i18n'
import { Text } from 'components/Text'
import { ThemeContext } from 'styled-components'
import { InputProps } from './Input.props'
import {
  InputRoot,
  InputContainer,
  InputStyled,
  IconStyle,
  InputLabel,
  InputLabelSpan,
  InputMaskContainer,
} from './Input.styled'

export const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      required = false,
      label,
      placeholder = '',
      placeholderTx,
      onChange,
      onTextChange,
      disabled = false,
      defaultValue,
      className,
      style,
      error,
      height,
      RightIcon,
      rightIconStyle,

      LeftIcon,
      leftIconStyle,
      min,
      max,
      touch = false,
      fullWidth = false,
      value,
      currencyMask,
      mask,
      format,
      isAllowed,
      noMargin = false,
      ...props
    },
    forwardedRef
  ) => {
    const theme = useContext(ThemeContext)
    const [touched, setTouched] = useState<boolean>(touch)

    const handleChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
      const text = evt.currentTarget.value
      if (onChange) onChange(evt)
      if (onTextChange) onTextChange(mask ? text.replace(/\s+/g, '') : text)
    }

    const placeholderText = placeholderTx ? placeholderTx : placeholder
    const rIconStyle = IconStyle(theme, { ...rightIconStyle, marginLeft: 5 })
    const lIconStyle = IconStyle(theme, { ...leftIconStyle, marginRight: 5 })

    return (
      <InputRoot noMargin={noMargin} fullWidth={fullWidth} height={height}>
        {label && (
          <InputLabel>
            {label}
            {required && <InputLabelSpan>*</InputLabelSpan>}
          </InputLabel>
        )}
        {mask && format && !currencyMask && (
          <InputMaskContainer
            fullWidth={fullWidth}
            touched={touched}
            disabled={disabled}
            style={style}
            className={className}
            onFocus={() => setTouched(true)}
            error={!!error}
            format={format}
            value={value !== undefined ? value : undefined}
            placeholder={placeholder}
            mask={mask}
            isAllowed={isAllowed}
            onChange={handleChange}
          />
        )}
        {currencyMask && (
          <InputMaskContainer
            fullWidth={fullWidth}
            touched={touched}
            disabled={disabled}
            style={style}
            className={className}
            onFocus={() => setTouched(true)}
            error={!!error}
            placeholder={placeholder}
            value={value !== undefined ? value : undefined}
            thousandSeparator={currencyMask && ','}
            decimalSeparator={currencyMask && '.'}
            prefix={currencyMask && '$'}
            decimalScale={2}
            fixedDecimalScale={true}
            onValueChange={(values: { value: string }) => {
              const { value } = values
              if (onTextChange) onTextChange(value)
            }}
          />
        )}
        {!mask && !format && !currencyMask && (
          <InputContainer
            fullWidth={fullWidth}
            touched={touched}
            disabled={disabled}
            className={className}
            onFocus={() => setTouched(true)}
            style={style}
            error={!!error}>
            {LeftIcon && <LeftIcon style={lIconStyle} />}
            <InputStyled
              {...props}
              value={value !== undefined ? value : undefined}
              onChange={handleChange}
              defaultValue={defaultValue}
              ref={forwardedRef}
              style={style}
              disabled={disabled}
              min={min}
              max={max}
              placeholder={placeholderText}
              touched={RightIcon || LeftIcon ? false : touched}
            />
            {RightIcon && <RightIcon style={rIconStyle} />}
          </InputContainer>
        )}

        {error && (
          <Text color="error" preset="small">
            {error}
          </Text>
        )}
      </InputRoot>
    )
  }
)
